import type { ObjectId } from "@bbj-types/utils";
import type { WorkshopInvitationStatus } from "@bbj-types/workshop";
import { useCallback } from "react";
import { workshopsAxios } from "./axios";

interface IPatchWorkshopParticipantsBody {
  invitationStatus?: WorkshopInvitationStatus;
  convocationTime?: ObjectId;
}

export const usePatchWorkshopParticipants = () => {
  const [state, execute, cancel] = workshopsAxios<void>(
    {
      url: "/:id/participants",
      method: "PATCH",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (workshopId: ObjectId, participantsIds: ObjectId[], data: IPatchWorkshopParticipantsBody) => {
      return execute({
        url: `/${workshopId}/participants`,
        params: { ids: participantsIds },
        data,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
